import { SyntheticEvent } from 'react';

class SyntheticEventHelper {
  static preventTouchMove(event: SyntheticEvent) {
    if (event && event.type === 'touchmove' && event.cancelable) {
      event.preventDefault();
    }
  }
}

export default SyntheticEventHelper;
